<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>Modification de commande</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent">
    </mat-progress-bar>
    <form class="edit-form" [formGroup]="editForm" (submit)="onSubmit()" *ngIf="editForm">

      <div class="ordererSiteSection">

        <section class="ordererSection">
          <h3>Demandeur</h3>
          <div class="ordererFields">
            <mat-form-field class="ordererName-field">
              <mat-label>{{'orders.create.ordererName.label' | translate}}</mat-label>
              <input matInput formControlName="ordererName">
              <mat-error>{{ 'orders.create.ordererName.errorMessage' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="ordererPhone-field">
              <mat-label>{{'orders.create.ordererPhone.label' | translate}}</mat-label>
              <input matInput formControlName="ordererPhone">
              <mat-error>{{ 'orders.create.ordererPhone.errorMessage' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="callDate-field">
              <mat-label>Heure d'appel</mat-label>
              <input id="inputTime" type="time" matInput formControlName="callDate">
            </mat-form-field>

            <section *ngIf="lots && lots.length > 0 && !isLoadingLots && editForm.get('site').value">
              <app-autocomplete [control]="getControl('lot')" [list]="lots"
                label="orders.create.lot"></app-autocomplete>
            </section>

            <mat-spinner *ngIf="isLoadingLots" color="primary" [diameter]="30"></mat-spinner>
          </div>
        </section>
      </div>

      <section>
        <h3>Commentaires sur la course</h3>
        <mat-form-field class="comment-field">
          <textarea matInput rows="5" formControlName="ordererComment"></textarea>
          <mat-error>{{ 'orders.create.ordererComment.error' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section>
        <h3>{{'orders.create.transportType.label' | translate}}</h3>

        <mat-form-field class="devicesChipList">
          <mat-chip-grid #chipList aria-label="Device selection">
            <mat-chip-row *ngFor="let selected of transportTypesSelected" [selectable]="selectable"
              [removable]="removable" (removed)="remove(selected)">
              {{selected.name}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
            <input placeholder="Sélectionnez un type de transport" #deviceInput id="deviceChipList"
              [formControl]="transportTypesCtrl" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur" [matAutocomplete]="auto" [matChipInputFor]="chipList">
            <button type="button" mat-icon-button color="primary" *ngIf="transportTypesSelected.length > 0"
              (click)="clearDevicesSelected()">
              <mat-icon class="clearButton" (click)="clearDevicesSelected()">clear</mat-icon>
            </button>
          </mat-chip-grid>
          <mat-autocomplete class="devicesDropdown" #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let device of filteredTransportTypes | async" [value]="device"
              [disabled]="device.selected">
              {{device.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </section>

      <section>
        <h3>{{'orders.create.urgencyLevel' | translate}} <span class="red">*</span></h3>
        <mat-radio-group aria-label="Sélectionnez un niveau d'urgence" class="urgency-field"
          formControlName="urgencyLevel">
          <mat-radio-button *ngFor="let urgencyLevel of urgencyLevels" [checked]="urgencyLevel.isChecked"
            [value]="urgencyLevel">{{urgencyLevel.name}}</mat-radio-button>
        </mat-radio-group>
      </section>

      <section *ngIf="isControlSet('schedule')" class="date-field">
        <h3>Date, heure de prise en charge souhaitée <span class="red">*</span> | Rappel</h3>
        <mat-list formArrayName="schedule">
          <mat-list-item *ngFor="let control of getArray('schedule').controls; index as i" [formGroupName]="i">
            <div matLine>
              <mat-form-field class="start-date-field">
                <mat-label>Date</mat-label>
                <input matInput formControlName="startDate" [matDatepicker]="startDatePicker"
                  [errorStateMatcher]="confirmValidMatcher" (click)="resetStartDate(control)">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="start-time-field">
                <mat-label>Heure</mat-label>
                <input id="inputTime" type="time" matInput formControlName="startTime"
                  [errorStateMatcher]="confirmValidMatcher">
              </mat-form-field>

              <mat-form-field class="recall-timer-field">
                <mat-label>Rappel (min)</mat-label>
                <input type="number" matInput formControlName="recallTimer">
              </mat-form-field>


            </div>
            <div matLine *ngIf="control.hasError('mismatch')" class="schedule-error">
              {{ 'orders.create.startDate.errorMessage' | translate }}
            </div>
          </mat-list-item>
        </mat-list>
      </section>

      <section *ngIf="isControlSet('sender')">
        <mat-list formArrayName="sender">
          <mat-list-item class="oneReceiver" *ngFor="let control of getArray('sender').controls; index as i"
            [formGroupName]="i">
            <div matLine>

              <fieldset class="fieldsetSender">
                <legend>Lieu d'enlèvement - Étape 1<span class="red">*</span></legend>
                <section>
                  <h3>Adresse <span class="red">*</span></h3>

                  <app-autocomplete class="site-field" [control]="control.get('address')" [list]="senders"
                    errorMsg="orders.create.sender.errorMessage" [canString]="true">
                  </app-autocomplete>

                </section>

                <section>
                  <h3>{{'orders.create.senderService.label' | translate}} <span class="red">*</span></h3>
                  <mat-form-field class="senderService-field">
                    <input matInput formControlName="service">
                    <mat-error>{{ 'orders.create.senderService.errorMessage' | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>

                <section>
                  <h3>{{'orders.create.ordererComment.title' | translate}}</h3>
                  <mat-form-field class="comment-field">
                    <textarea matInput rows="5" formControlName="ordererComment"></textarea>
                    <mat-error>{{ 'orders.create.ordererComment.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>
              </fieldset>

            </div>
          </mat-list-item>
        </mat-list>
      </section>

      <section *ngIf="isControlSet('receivers')">
        <mat-list formArrayName="receivers">
          <mat-list-item class="oneReceiver" *ngFor="let control of getArray('receivers').controls; index as i"
            [formGroupName]="i">
            <div matLine>
              <fieldset>
                <legend>
                  <span>Étape {{i + 2}} </span>
                  <span *ngIf="i === 0" class="red">*</span>
                </legend>

                <section *ngIf="getArray('receivers').controls.length > 1">
                  <mat-radio-group formControlName="type">
                    <mat-radio-button value="isDelivery">Livraison</mat-radio-button>
                    <mat-radio-button value="isPickup">Enlèvement</mat-radio-button>
                  </mat-radio-group>
                </section>

                <section>
                  <h3>Adresse <span class="red">*</span></h3>

                  <app-autocomplete class="site-field" [control]="control.get('address')" [list]="receivers"
                    errorMsg="orders.create.receiver.errorMessage" [canString]="true">
                  </app-autocomplete>

                </section>

                <section>
                  <h3>{{'orders.create.receiverService.label' | translate}} <span class="red">*</span></h3>
                  <mat-form-field class="receiverService-field">
                    <input matInput formControlName="service">
                    <mat-error>{{ 'orders.create.receiverService.errorMessage' | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>

                <section>
                  <h3>{{'orders.create.ordererComment.title' | translate}}</h3>
                  <mat-form-field class="comment-field">
                    <textarea matInput rows="5" formControlName="ordererComment"></textarea>
                    <mat-error>{{ 'orders.create.ordererComment.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>

                <section *ngIf="isControlPatientSet(i)">
                  <fieldset class="patients-list">
                    <legend>
                      <h3>{{'orders.create.patients.title' | translate}}</h3>
                    </legend>
                    <mat-list formArrayName="patients">
                      <mat-list-item *ngFor="let control of getArrayPatients(i).controls; index as i2"
                        [formGroupName]="i2" class="listPatients">
                        <div matLine>

                          <mat-form-field>
                            <mat-label>{{'orders.create.patients.firstname.label' | translate}}</mat-label>
                            <input matInput formControlName="firstname">
                            <mat-error>{{ 'orders.create.patients.firstname.errorMessage' | translate}}</mat-error>
                          </mat-form-field>

                          <mat-form-field>
                            <mat-label>{{'orders.create.patients.birthname.label' | translate}}</mat-label>
                            <input matInput formControlName="birthname">
                            <mat-error>{{ 'orders.create.patients.birthname.errorMessage' | translate}}</mat-error>
                          </mat-form-field>

                          <mat-form-field>
                            <mat-label>{{'orders.create.patients.lastname.label' | translate}}</mat-label>
                            <input matInput formControlName="lastname">
                            <mat-error>{{ 'orders.create.patients.lastname.errorMessage' | translate}}</mat-error>
                          </mat-form-field>

                          <mat-form-field class="birthdate-field">
                            <mat-label>{{'orders.create.patients.birthdate.label' | translate}}</mat-label>
                            <input matInput formControlName="birthdate" [matDatepicker]="birthdatePicker"
                              (click)="resetBirthDate(control)">
                            <mat-datepicker-toggle matSuffix [for]="birthdatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #birthdatePicker></mat-datepicker>
                            <mat-error>{{ 'orders.create.patients.birthdate.errorMessage' | translate}}</mat-error>
                          </mat-form-field>

                          <mat-form-field class="ippField">
                            <mat-label>IPP F/M</mat-label>
                            <input matInput formControlName="ipp" [matTooltip]="control.value.ipp">
                            <mat-error>Max 50 caractères</mat-error>
                          </mat-form-field>

                          <mat-form-field>
                            <mat-label>{{'orders.create.patients.productType.label' | translate}}</mat-label>
                            <input matInput formControlName="productType">
                            <mat-error>{{ 'orders.create.patients.productType.errorMessage' | translate}}</mat-error>
                          </mat-form-field>

                          <mat-form-field class="quantityField">
                            <mat-label>{{'orders.create.patients.quantity.label' | translate}}</mat-label>
                            <input matInput type="number" formControlName="quantity">
                            <mat-error>{{ 'orders.create.patients.quantity.errorMessage' | translate}}</mat-error>
                          </mat-form-field>

                          <button type="button" mat-icon-button color="primary" (click)="onCopyPatient(i, control)">
                            <mat-icon aria-label="delete">content_copy</mat-icon>
                          </button>

                          <button type="button" mat-icon-button color="primary" (click)="onRemovePatient(i, i2)">
                            <mat-icon aria-label="delete">delete</mat-icon>
                          </button>
                        </div>
                      </mat-list-item>
                      <mat-list-item>
                        <button type="button" mat-icon-button color="primary" (click)="onAddPatient(i)"
                          matTooltip="Ajouter un patient">
                          <mat-icon aria-label="Add">add</mat-icon>
                        </button>
                      </mat-list-item>
                    </mat-list>
                  </fieldset>
                </section>

              </fieldset>


            </div>
            <button *ngIf="i !== 0" type="button" matTooltip="Retirer le destinataire" mat-icon-button color="primary"
              (click)="onRemoveReceiver(i)">
              <mat-icon aria-label="delete">delete</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item *ngIf="!isClient && getArray('receivers').controls.length < 100">
            <button type="button" mat-icon-button color="primary" matTooltip="Ajouter un destinataire"
              (click)="onAddReceiver()">
              <mat-icon aria-label="Add">add</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </section>

      <section class="actions">
        <div class="checkButton" [matTooltip]="invalidMessage"
          [matTooltipDisabled]="editForm.valid && transportTypesSelected.length !== 0 && this.editForm.value.receivers[this.editForm.value.receivers.length - 1].type !== 'isPickup'">
          <button *ngIf="!isLoading" type="submit" mat-icon-button color="primary"
            [disabled]="editForm.invalid || transportTypesSelected.length === 0 || this.editForm.value.receivers[this.editForm.value.receivers.length - 1].type === 'isPickup'">
            <mat-icon aria-label="Validate">check</mat-icon>
          </button>
        </div>
        <button *ngIf="!isLoading" type="button" mat-icon-button (click)="onFinish()">
          <mat-icon aria-label="Cancel">clear</mat-icon>
        </button>
        <mat-spinner class="spinnerLoading" *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
      </section>
    </form>
  </mat-card-content>
</mat-card>
